"use strict";
/**
 * Time-Off Constants
 *
 * Mexican labor law vacation tables and related constants.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VACATION_CONSUMING_TYPES = exports.LEGAL_VACATIONS = void 0;
const time_off_enums_1 = require("./time-off.enums");
/**
 * Legal vacation days per anniversary year (Mexican Federal Labor Law, Art. 76).
 *
 * - `old`: Pre-2023 reform (Ley Federal del Trabajo original)
 * - `new`: Post-2022 reform (effective Jan 1, 2023 — doubled minimums)
 *
 * Index = years of service (0 = year of hire, 1 = first anniversary, etc.)
 * Values for ranges (e.g., years 5-9) are repeated for each year in range.
 */
exports.LEGAL_VACATIONS = {
    old: [
        0, // 0 years
        6, // 1
        8, // 2
        10, // 3
        12, // 4
        14, // 5
        14, // 6
        14, // 7
        14, // 8
        14, // 9
        16, // 10
        16, // 11
        16, // 12
        16, // 13
        16, // 14
        18, // 15
        18, // 16
        18, // 17
        18, // 18
        18, // 19
        20, // 20
        20, // 21
        20, // 22
        20, // 23
        20, // 24
        22, // 25
        22, // 26
        22, // 27
        22, // 28
        22, // 29
        24, // 30
    ],
    new: [
        0, // 0 years
        12, // 1
        14, // 2
        16, // 3
        18, // 4
        20, // 5
        22, // 6
        22, // 7
        22, // 8
        22, // 9
        22, // 10
        24, // 11
        24, // 12
        24, // 13
        24, // 14
        26, // 15
        26, // 16
        26, // 17
        26, // 18
        26, // 19
        28, // 20
        28, // 21
        28, // 22
        28, // 23
        28, // 24
        30, // 25
        30,
        30,
        30,
        30,
        30,
    ],
};
/**
 * TimeOffTypes that consume vacation balance.
 * Only these types count against a collaborator's vacation days.
 *
 * NOTE: TimeOffType.PaidLeave (Permiso con goce de sueldo) is intentionally
 * EXCLUDED — a paid leave pays full salary but must NOT consume vacation days.
 */
exports.VACATION_CONSUMING_TYPES = [
    time_off_enums_1.TimeOffType.Vacation,
    time_off_enums_1.TimeOffType.PersonalLeave,
];
